import { EventKind, Notification } from "@nova/schemas"
import { isMentionNotification } from "@nova/notifications"

export type NotificationTabKind = "mentions" | "jobs"

export const notificationMatchesTab = (n: Notification, tab: NotificationTabKind): boolean => {
    if (tab === "jobs") {
        return n.kind === EventKind.LayerProcessed || n.kind === EventKind.LayerProcessingFailed
    }
    return isMentionNotification(n)
}
